import React from 'react';
import { Brain, Cpu, Network } from 'lucide-react';

const TitleSlide = () => {
  return (
    <div className="slide active min-h-screen w-full flex flex-col justify-center items-center px-6 md:px-12 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full opacity-20 animate-float" style={{ background: 'var(--gradient-primary)', filter: 'blur(80px)' }} />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full opacity-15 animate-float" style={{ background: 'var(--gradient-primary)', filter: 'blur(100px)', animationDelay: '1s' }} />
      </div>
      
      <div className="relative z-10 text-center max-w-5xl stagger-children">
        {/* Icons row */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="p-3 rounded-xl bg-primary/10 border border-primary/20">
            <Brain className="w-8 h-8 text-primary" />
          </div>
          <div className="p-3 rounded-xl bg-secondary/10 border border-secondary/20">
            <Cpu className="w-8 h-8 text-secondary" />
          </div>
          <div className="p-3 rounded-xl bg-accent/10 border border-accent/20">
            <Network className="w-8 h-8 text-accent" />
          </div>
        </div>
        
        {/* Main title */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6">
          <span className="text-foreground">Reasoning Models</span>
          <br />
          <span className="text-gradient">From LLM Foundations to NOC Automation</span>
        </h1>
        
        {/* Subtitle */}
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
          Master-Level Course • Politehnica Bucharest
        </p>
        
        {/* Course info - Speaker */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
          <div className="text-center">
            <p className="text-xl md:text-2xl font-semibold text-foreground">Eduard Dulharu</p>
            <p className="text-base text-primary">CTO vExpertAI GmbH • Munich, Germany</p>
          </div>
        </div>
        
        {/* Navigation hint */}
        <div className="flex items-center justify-center gap-3 text-sm text-muted-foreground">
          <span>Use</span>
          <kbd className="kbd">←</kbd>
          <kbd className="kbd">→</kbd>
          <span>or swipe to navigate</span>
        </div>
      </div>
    </div>
  );
};

export default TitleSlide;
